export default { PACKAGE_VERSION: "1.15.0" };
